<template>
  <div>
    <div id="logo">
      <img src="../assets/logo.jpg" alt="">
    </div>
    <div id="title">
      会员查询
    </div>
    <div id="input-area">
      <input v-model="name" type="text" placeholder="输入姓名">
      <input v-model="idCard" type="text" placeholder="输入身份证号码">
    </div>
    <div id="button">
      <button @click="searchClick">查询会员信息</button>
    </div>

    <div id="footer">
      <div id="redrect"></div>
      <div id="copyright">版权所有&copy;2023 中国摄影家艺术协会</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      idCard: ''
    }
  },

  created () {
    window.sessionStorage.clear()
  },

  methods: {
    async searchClick () {
      const { data: res } = await this.$http.get('user/query', {
        params: { name: this.name, idCard: this.idCard }
      })
      if (res.meta.status !== 200) {
        window.alert(res.meta.msg)
      } else {
        window.sessionStorage.setItem('userInfo', JSON.stringify(res.data))
        this.$router.push('/result')
      }
    }
  }
}
</script>

<style>

</style>
